import { render, staticRenderFns } from "./CategoryAddEdit.vue?vue&type=template&id=feb42406"
import script from "./CategoryAddEdit.vue?vue&type=script&lang=js"
export * from "./CategoryAddEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../Yobo/qraved-ordering-backoffice/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports